import { useState, useMemo } from 'react';
import { useAppData } from '../contexts/AppDataContext';

export interface Agent {
  name: string;
  microsoftId: string;
}

interface UseAgentsReturn {
  agents: Agent[];
  loading: boolean;
  error: string | null;
  selectedAgents: string[];
  allAgentIds: string[];
  setSelectedAgents: (agents: string[]) => void;
}

export function useAgents(initialSelectedAgents: string[] = [""]): UseAgentsReturn {
  const { uniqueAgents, loaded, errors } = useAppData();
  const [selectedAgents, setSelectedAgents] = useState<string[]>(initialSelectedAgents);

  const allAgentIds = useMemo(() =>
    uniqueAgents
      .filter(agent => agent.microsoftId !== "")
      .map(agent => agent.microsoftId),
    [uniqueAgents]
  );

  return {
    agents: uniqueAgents,
    loading: !loaded,
    error: errors.agents,
    selectedAgents,
    setSelectedAgents,
    allAgentIds,
  };
} 